import { Button } from '../../components/button/button';
import { ErrorPageContentBase } from '../../components/error-page-content-base/error-page-content-base';

export const ErrorPageContentClient = ({
  message,
  reset,
}: {
  message?: string;
  reset?: () => void;
}) => {
  const tryAgainLabel = 'Try again';

  return (
    <ErrorPageContentBase
      actionsSlot={reset && <Button onClick={() => reset()}>{tryAgainLabel}</Button>}
      message={message ?? 'Something went wrong, please try again later'}
    />
  );
};
